import { PAYMENT_MODE_ACTIONS } from '../actions/paymentModeActions';

const initialState = {
  paymentModes: [],
  activePaymentModes: [],
  currentPaymentMode: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 50,
    hasNextPage: false,
    hasPrevPage: false
  },
  loading: false,
  error: null,
  lastAction: null
};

const paymentModeReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get payment modes
    case PAYMENT_MODE_ACTIONS.GET_PAYMENT_MODES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        lastAction: 'GET_PAYMENT_MODES'
      };

    case PAYMENT_MODE_ACTIONS.GET_PAYMENT_MODES_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentModes: action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
        lastAction: 'GET_PAYMENT_MODES_SUCCESS'
      };

    case PAYMENT_MODE_ACTIONS.GET_PAYMENT_MODES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastAction: 'GET_PAYMENT_MODES_FAILURE'
      };

    // Get active payment modes
    case PAYMENT_MODE_ACTIONS.GET_ACTIVE_PAYMENT_MODES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        lastAction: 'GET_ACTIVE_PAYMENT_MODES'
      };

    case PAYMENT_MODE_ACTIONS.GET_ACTIVE_PAYMENT_MODES_SUCCESS:
      return {
        ...state,
        loading: false,
        activePaymentModes: action.payload.data || [],
        error: null,
        lastAction: 'GET_ACTIVE_PAYMENT_MODES_SUCCESS'
      };

    case PAYMENT_MODE_ACTIONS.GET_ACTIVE_PAYMENT_MODES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastAction: 'GET_ACTIVE_PAYMENT_MODES_FAILURE'
      };

    // Get payment mode by ID
    case PAYMENT_MODE_ACTIONS.GET_PAYMENT_MODE_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        lastAction: 'GET_PAYMENT_MODE_BY_ID'
      };

    case PAYMENT_MODE_ACTIONS.GET_PAYMENT_MODE_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        currentPaymentMode: action.payload.data,
        error: null,
        lastAction: 'GET_PAYMENT_MODE_BY_ID_SUCCESS'
      };

    case PAYMENT_MODE_ACTIONS.GET_PAYMENT_MODE_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastAction: 'GET_PAYMENT_MODE_BY_ID_FAILURE'
      };

    // Create payment mode
    case PAYMENT_MODE_ACTIONS.CREATE_PAYMENT_MODE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        lastAction: 'CREATE_PAYMENT_MODE'
      };

    case PAYMENT_MODE_ACTIONS.CREATE_PAYMENT_MODE_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentModes: [action.payload.data, ...state.paymentModes],
        error: null,
        lastAction: 'CREATE_PAYMENT_MODE_SUCCESS'
      };

    case PAYMENT_MODE_ACTIONS.CREATE_PAYMENT_MODE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastAction: 'CREATE_PAYMENT_MODE_FAILURE'
      };

    // Update payment mode
    case PAYMENT_MODE_ACTIONS.UPDATE_PAYMENT_MODE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        lastAction: 'UPDATE_PAYMENT_MODE'
      };

    case PAYMENT_MODE_ACTIONS.UPDATE_PAYMENT_MODE_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentModes: state.paymentModes.map(paymentMode =>
          paymentMode.id === action.payload.data.id ? action.payload.data : paymentMode
        ),
        currentPaymentMode: action.payload.data,
        error: null,
        lastAction: 'UPDATE_PAYMENT_MODE_SUCCESS'
      };

    case PAYMENT_MODE_ACTIONS.UPDATE_PAYMENT_MODE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastAction: 'UPDATE_PAYMENT_MODE_FAILURE'
      };

    // Delete payment mode
    case PAYMENT_MODE_ACTIONS.DELETE_PAYMENT_MODE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        lastAction: 'DELETE_PAYMENT_MODE'
      };

    case PAYMENT_MODE_ACTIONS.DELETE_PAYMENT_MODE_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentModes: state.paymentModes.filter(paymentMode => paymentMode.id !== action.payload),
        currentPaymentMode: state.currentPaymentMode?.id === action.payload ? null : state.currentPaymentMode,
        error: null,
        lastAction: 'DELETE_PAYMENT_MODE_SUCCESS'
      };

    case PAYMENT_MODE_ACTIONS.DELETE_PAYMENT_MODE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastAction: 'DELETE_PAYMENT_MODE_FAILURE'
      };

    // Toggle payment mode status
    case PAYMENT_MODE_ACTIONS.TOGGLE_PAYMENT_MODE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        lastAction: 'TOGGLE_PAYMENT_MODE_STATUS'
      };

    case PAYMENT_MODE_ACTIONS.TOGGLE_PAYMENT_MODE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentModes: state.paymentModes.map(paymentMode =>
          paymentMode.id === action.payload.data.id ? action.payload.data : paymentMode
        ),
        currentPaymentMode: state.currentPaymentMode?.id === action.payload.data.id ? action.payload.data : state.currentPaymentMode,
        error: null,
        lastAction: 'TOGGLE_PAYMENT_MODE_STATUS_SUCCESS'
      };

    case PAYMENT_MODE_ACTIONS.TOGGLE_PAYMENT_MODE_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastAction: 'TOGGLE_PAYMENT_MODE_STATUS_FAILURE'
      };

    // Clear errors
    case PAYMENT_MODE_ACTIONS.CLEAR_PAYMENT_MODE_ERRORS:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};

export default paymentModeReducer;
